import React, { useState, useEffect } from 'react';
import { useLocation,useNavigate } from 'react-router-dom';
import './assets/css/style.css';
import './assets/css/nice-select.css';
import './assets/css/swiper-bundle.min.css';
import './assets/css/jquery.fancybox.min.css';
import './assets/css/animate.css';
import './assets/css/boxicons.min.css';
import './assets/css/bootstrap-icons.min.css';
import './assets/css/bootstrap.min.css';
import './assets/css/boxicons.min.css';
import '../emagazine/assets/css/new_style.css'
import BybFooter from '../../Components/BybMainPage/BybFooter/BybFooter.jsx';
import { demoteArticleBodyH1Tags } from './articleHeadingUtils.js';
import { copyTextToClipboard } from './clipboardUtils.js';
import { buildEmagazineArticlePath, buildEmagazineCategoryPath } from './emagazineApi.js';



const BlogDetailPageDemo = () =>
{
    const navigate = useNavigate();

        const [showHamburgerMenu, setshowHamburgerMenu] = useState(false)
    const handleHamburgerMenu = ()=>{
        setshowHamburgerMenu((preState)=>!preState)
        console.log('clicked');
    }

        const location = useLocation();
        const getCategoryHref = (name) => buildEmagazineCategoryPath(name);

        const lastSegment = decodeURIComponent(window.location.pathname.split("/").pop());
        const pathSegments = window.location.pathname.split('/').filter(Boolean);
        const secondLastSegment = pathSegments.length >= 2 ? decodeURIComponent(pathSegments[pathSegments.length - 2]) : null;

        const [posts, setPosts] = useState([]);
        const [isLoading, setIsLoading] = useState(true);   // Add loading state
        const [error, setError] = useState(null);           // Add error handling

        useEffect(() => {
            const fetchPostsByCategory = async () => {
                if (!secondLastSegment) return;

                try {
                    const response = await fetch(
                        `https://api.skepper.in/get_featured_blogs_by_category.php?category=${encodeURIComponent(secondLastSegment)}`
                    );

                    if (!response.ok) throw new Error('Failed to fetch posts');

                    const data = await response.json();

                    setPosts(data.success ? data.blogs : []);
                    setIsLoading(false);
                } catch (error) {
                    console.error("Error fetching posts:", error);
                    setError('Failed to load posts');
                    setIsLoading(false);
                }
            };

            fetchPostsByCategory();
        }, [secondLastSegment]);

        const [categories, setCategories] = useState([]);

        const [blogData, setBlogData] = useState(null);

        useEffect(() => {
            const fetchCategories = async () => {
                try {
                    const response = await fetch("https://api.skepper.in/get_categories.php");
                    const data = await response.json();

                    if (data.success) {
                        setCategories(data.categories);
                    } else {
                        console.error("Failed to fetch categories");
                    }
                } catch (error) {
                    console.error("Error fetching categories:", error);
                }
            };

            fetchCategories();
        }, []);

        useEffect(() => {
            const fetchBlogData = async () => {
                try {
                    const response = await fetch(`https://api.skepper.in/get_blogs_by_slug.php?slug=${lastSegment}`);
                    const data = await response.json();
                    console.log(data.blogs[0].id);
                    if (data.success) {
                        setBlogData(data.blogs[0]); // Assuming you need the first blog
                    } else {
                        setError(data.message);
                    }
                } catch (err) {
                    setError("Failed to fetch blog data.");
                }
            };

            fetchBlogData();
        }, [lastSegment]);

        const currentUrl = window.location.href;
        const [isLinkCopied, setIsLinkCopied] = useState(false);

        const handleCopyLink = async () => {
            try {
                await copyTextToClipboard(currentUrl);
                setIsLinkCopied(true);
                window.setTimeout(() => setIsLinkCopied(false), 2000);
            } catch (error) {
                console.error('Unable to copy article link:', error);
            }
        };
        const normalizedBlogContent = blogData?.content
            ? demoteArticleBodyH1Tags(blogData.content)
            : "";

        const [email, setEmail] = useState("");
        const [message, setMessage] = useState("");
        const [messageType, setMessageType] = useState("");

        const validateEmail = (email) => {
            return /\S+@\S+\.\S+/.test(email);
        };

        const handleSubscribe = async () => {
            if (!validateEmail(email)) {
                setMessage("❌ Please enter a valid email address.");
                setMessageType("error");
                return;
            }

            const formData = { email };

            try {
                const response = await fetch(
                    "https://api.skepper.in/subscriber-submit.php",
                    {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify(formData),
                    }
                );

                const data = await response.json();

                if (data.success) {
                    setMessage("✅ Thank you for subscribing!");
                    setMessageType("success");
                    setEmail(""); // Clear input after successful subscription
                } else {
                    setMessage("❌ Subscription failed. Please try again.");
                    setMessageType("error");
                }
            } catch (error) {
                setMessage("❌ An error occurred. Please try again later.");
                setMessageType("error");
            }
        };

        const [randomPosts, setRandomPosts] = useState([]);

        useEffect(() => {
            const fetchRandomPosts = async () => {
                setIsLoading(true);
                setError(null);

                try {
                    const response = await fetch("https://api.skepper.in/random-posts.php");

                    if (!response.ok) throw new Error("Failed to fetch random posts");

                    const data = await response.json();

                    if (data.success && Array.isArray(data.blogs)) {
                        // ✅ Shuffle posts and pick two random ones
                        const shuffled = data.blogs.sort(() => 0.5 - Math.random());
                        const randomTwo = shuffled.slice(0, 2);
                        setRandomPosts(randomTwo);
                    } else {
                        setRandomPosts([]);
                    }
                } catch (error) {
                    console.error("Error fetching random posts:", error);
                    setError("Failed to load posts.");
                } finally {
                    setIsLoading(false);
                }
            };

            fetchRandomPosts();
        }, []);

        // Fetch Featured Posts (from random-posts.php)
        useEffect(() => {
            const fetchFeaturedPosts = async () => {
                setIsLoading(true);
                setError(null); // Reset error before fetch

                try {
                    // Fetching from the random-posts endpoint
                    const response = await fetch("https://api.skepper.in/random-posts.php");

                    if (!response.ok) {
                        // Handle HTTP errors (like 404, 500)
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }

                    const data = await response.json();

                    // Check the structure of the JSON response from the API
                    if (data.success && Array.isArray(data.data)) {
                        const posts = data.data; // Correctly using data.data

                        if (posts.length === 0) {
                            // API call was successful, but no posts were returned
                            setRandomPosts([]);
                            // Set an informational message (can be cleared if you prefer silence)
                            setError("No posts available.");
                        } else {
                            // Posts found and returned successfully
                            setRandomPosts(posts);
                            setError(null); // Clear any previous error/message
                        }
                    } else {
                        // Handle API indicating failure (data.success is false) or unexpected structure
                        setRandomPosts([]);
                        setError(data.message || "Failed to load posts due to API error.");
                    }
                } catch (error) {
                    // Handle network errors or errors thrown above (like !response.ok or json parsing issues)
                    console.error("Error fetching random posts:", error);
                    setError(error.message || "Failed to load posts due to network or server issue.");
                    setRandomPosts([]); // Ensure posts array is empty on error
                } finally {
                    // Ensure loading state is always turned off
                    setIsLoading(false);
                }
            };

            fetchFeaturedPosts();
        }, []); // Empty dependency array means this runs once when the component mounts

        const handleToggle = async (blogId, field, value) => {
            try {
              const response = await fetch('https://api.skepper.in/blog_status.php', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                  id: blogId,
                  field: field,
                  value: value
                }),
              });

              const data = await response.json();

              if (data?.success) {
                console.log(`Updated ${field} successfully to ${value}`);
                // Optional: update state instead of full reload
                window.location.reload();
              } else {
                console.error(`Failed to update ${field}: ${data?.message || 'Unknown error'}`);
              }
            } catch (error) {
              console.error('Error toggling blog status:', error);
            }
          };




    return (
        <>
 <div className='' >



    <div className={`${showHamburgerMenu ? "show-menu" : ""} sidebar-menu d-lg-none d-sm-block`}>
    <div className="mobile-logo-area d-flex justify-content-between align-items-center">
                <div className="header-logo">
                    <a href="/e-magazine/"><img alt="Brew Your Brand eMagazine logo" className="img-fluid dark" src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/logo.svg" /></a>
                    <a href="/e-magazine/"><img alt="Brew Your Brand eMagazine logo" className="img-fluid light" src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/logo.svg" /></a>
                </div>
                <div className="menu-button menu-close-btn" onClick={handleHamburgerMenu}>
                    <i className="bi bi-x"></i>
                </div>
            </div>

            <ul className="menu-list">
                    {categories.map(category => (
                            <li key={category.id}>
                                <a href={getCategoryHref(category.name)}>{category.name} </a>
                            </li>
                    ))}
            </ul>

            <div className="menu-bottom-content">
                <div class="menu-bottom-content">
            <div class="header-right">
                <a href="javascript:void(0)"  class="submit_quote" id="visual-projects">Submit Your Article</a>
                <li class=" " id="popup-container">
                    <div data-tf-live="01JSY0YC8JZVDTTCVBWM28RKPN" class="article_form"></div>
                 </li>
            </div>

            <div class="social-wrap">
                <h6>Follow Social Media </h6>
                <ul class="social-area">
                    <li>
                        <a href="https://www.facebook.com/BrewYourBrandOfficial">
                            <svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M7.81526 12.2483V7.46726H9.42818L9.66793 5.59534H7.81526V4.40301C7.81526 3.86284 7.96576 3.49301 8.74101 3.49301H9.72334V1.82409C9.24538 1.77287 8.76495 1.74814 8.28426 1.75001C6.85859 1.75001 5.87976 2.62034 5.87976 4.21809V5.59184H4.27734V7.46376H5.88326V12.2483H7.81526Z">
                                </path>
                            </svg>
                        </a>
                    </li>
                    <li>
                        <a href="https://x.com/brew_your_brand">
                            <svg width="12" height="12" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
                                <g>
                                    <path
                                        d="M11.025 0.65625H13.1722L8.48225 6.0305L14 13.3438H9.68012L6.2965 8.9075L2.42462 13.3438H0.2765L5.29287 7.595L0 0.65625H4.43013L7.48825 4.71012L11.025 0.65625ZM10.2725 12.0557H11.4625L3.78262 1.87687H2.50688L10.2725 12.0557Z">
                                    </path>
                                </g>
                            </svg>
                        </a>
                    </li>
                    <li>
                        <a href="https://www.linkedin.com/company/brew-your-brand">
                            <svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M2.90719 4.1972C3.61209 4.1972 4.18353 3.62576 4.18353 2.92086C4.18353 2.21597 3.61209 1.64453 2.90719 1.64453C2.20229 1.64453 1.63086 2.21597 1.63086 2.92086C1.63086 3.62576 2.20229 4.1972 2.90719 4.1972Z">
                                </path>
                                <path
                                    d="M5.38752 5.16523V12.2463H7.5861V8.74457C7.5861 7.82057 7.75994 6.92573 8.9056 6.92573C10.0355 6.92573 10.0495 7.98215 10.0495 8.8029V12.2469H12.2493V8.36365C12.2493 6.45615 11.8386 4.99023 9.60911 4.99023C8.53869 4.99023 7.82119 5.57765 7.52777 6.13357H7.49802V5.16523H5.38752ZM1.80469 5.16523H4.00677V12.2463H1.80469V5.16523Z">
                                </path>
                            </svg>
                        </a>
                    </li>
                    <li>
                        <a href="https://www.instagram.com/brew_your_brand">
                            <svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M12.2191 4.84492C12.2132 4.40312 12.1305 3.96571 11.9747 3.55226C11.8396 3.20351 11.6332 2.88679 11.3687 2.62233C11.1043 2.35786 10.7875 2.15147 10.4388 2.01634C10.0307 1.86313 9.59948 1.78029 9.16362 1.77134C8.60246 1.74626 8.42454 1.73926 7.00004 1.73926C5.57554 1.73926 5.39296 1.73926 4.83587 1.77134C4.40022 1.78036 3.96924 1.8632 3.56129 2.01634C3.21249 2.15138 2.89572 2.35773 2.63124 2.62221C2.36677 2.88669 2.16041 3.20346 2.02537 3.55226C1.87186 3.96008 1.7892 4.39116 1.78096 4.82684C1.75587 5.38859 1.74829 5.56651 1.74829 6.99101C1.74829 8.41551 1.74829 8.59751 1.78096 9.15517C1.78971 9.59151 1.87196 10.022 2.02537 10.4309C2.16064 10.7796 2.36715 11.0963 2.63171 11.3606C2.89628 11.625 3.21308 11.8313 3.56187 11.9663C3.96871 12.1256 4.39976 12.2144 4.83646 12.2288C5.39821 12.2538 5.57612 12.2614 7.00062 12.2614C8.42512 12.2614 8.60771 12.2614 9.16479 12.2288C9.60063 12.2202 10.0318 12.1375 10.44 11.9843C10.7886 11.8491 11.1053 11.6426 11.3697 11.3782C11.6341 11.1137 11.8406 10.7971 11.9759 10.4484C12.1293 10.0401 12.2115 9.60959 12.2203 9.17267C12.2454 8.61151 12.253 8.43359 12.253 7.00851C12.2518 5.58401 12.2518 5.40317 12.2191 4.84492ZM6.99654 9.68484C5.50671 9.68484 4.29979 8.47792 4.29979 6.98809C4.29979 5.49826 5.50671 4.29134 6.99654 4.29134C7.71176 4.29134 8.39769 4.57546 8.90343 5.0812C9.40917 5.58694 9.69329 6.27287 9.69329 6.98809C9.69329 7.70331 9.40917 8.38924 8.90343 8.89498C8.39769 9.40072 7.71176 9.68484 6.99654 9.68484ZM9.80062 4.82042C9.71802 4.8205 9.63622 4.80429 9.55989 4.77271C9.48356 4.74114 9.41421 4.69482 9.3558 4.63641C9.29739 4.57801 9.25108 4.50865 9.2195 4.43233C9.18793 4.356 9.17171 4.27419 9.17179 4.19159C9.17179 4.10905 9.18805 4.02732 9.21964 3.95106C9.25122 3.8748 9.29752 3.80551 9.35589 3.74714C9.41425 3.68878 9.48354 3.64248 9.5598 3.61089C9.63606 3.57931 9.71779 3.56305 9.80033 3.56305C9.88287 3.56305 9.96461 3.57931 10.0409 3.61089C10.1171 3.64248 10.1864 3.68878 10.2448 3.74714C10.3031 3.80551 10.3494 3.8748 10.381 3.95106C10.4126 4.02732 10.4289 4.10905 10.4289 4.19159C10.4289 4.53926 10.1477 4.82042 9.80062 4.82042Z">
                                </path>
                                <path
                                    d="M6.99589 8.73983C7.96336 8.73983 8.74764 7.95554 8.74764 6.98808C8.74764 6.02061 7.96336 5.23633 6.99589 5.23633C6.02843 5.23633 5.24414 6.02061 5.24414 6.98808C5.24414 7.95554 6.02843 8.73983 6.99589 8.73983Z">
                                </path>
                            </svg>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
            </div>
    </div>

    <div className="header-area2">
        <div className="container d-lg-flex align-items-center justify-content-between">
            <div className="header-menu-icon d-lg-none d-sm-block d-md-none">
                <div className="menu-icon" >
                    <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M1.66675 9.16666H18.3334V10.8333H1.66675V9.16666ZM1.66675 4.16666H18.3334V5.83332H1.66675V4.16666ZM1.66675 14.1667H18.3334V15.8333H1.66675V14.1667Z" />
                    </svg>
                </div>
                <div className="tt-style-switch">
                    <i className="bi bi-brightness-low-fill"></i>
                </div>
            </div>
            <div className="header-logo">
                <a href="https://brewyourbrand.in/"><img alt="Brew Your Brand logo" className="img-fluid dark" src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/logo.svg"/></a>
                <a href="https://brewyourbrand.in/"><img alt="Brew Your Brand logo" className="img-fluid light" src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/logo.svg"/></a>
            </div>
            <div className="header-right d-md-flex d-lg-none">
                <div className="search-bar">

                </div>
                <a href="javascript:void(0)" class="submit_quote" id="visual-projects">Submit Your Article</a>
                <li class=" " id="popup-container">
                    <div data-tf-live="01JSY0YC8JZVDTTCVBWM28RKPN" class="article_form"></div>
                </li>
                <div className="subscribe-btn ">
                    <a href="#" className="primary-btn hover-btn text-decoration-none">

                        Subscribe
                    </a>

                </div>
            </div>
        </div>
    </div>

    <header className="life-style d-lg-flex d-lg-none d-sm-block">
        <div className="container-md">
            <div className="col-lg-12 px-0">
                <div className="header-wrapper">
                    <div className="main-menu">
                        <ul className="menu-list">

                            {categories.map(category => (
    <li key={category.id}>
        <a href={getCategoryHref(category.name)}>
            {category.name}
        </a>
    </li>
))}

                        </ul>
                    </div>
                    <div className="nav-right d-flex jsutify-content-end align-items-center">
                        <ul className="social-area">
                            <li>
                                <a href="https://www.facebook.com/BrewYourBrandOfficial">
                                    <svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M7.81526 12.2483V7.46726H9.42818L9.66793 5.59534H7.81526V4.40301C7.81526 3.86284 7.96576 3.49301 8.74101 3.49301H9.72334V1.82409C9.24538 1.77287 8.76495 1.74814 8.28426 1.75001C6.85859 1.75001 5.87976 2.62034 5.87976 4.21809V5.59184H4.27734V7.46376H5.88326V12.2483H7.81526Z">
                                        </path>
                                    </svg>
                                </a>
                            </li>
                            <li>
                                <a href="https://x.com/brew_your_brand">
                                    <svg width="12" height="12" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
                                        <g>
                                            <path
                                                d="M11.025 0.65625H13.1722L8.48225 6.0305L14 13.3438H9.68012L6.2965 8.9075L2.42462 13.3438H0.2765L5.29287 7.595L0 0.65625H4.43013L7.48825 4.71012L11.025 0.65625ZM10.2725 12.0557H11.4625L3.78262 1.87687H2.50688L10.2725 12.0557Z">
                                            </path>
                                        </g>
                                    </svg>
                                </a>
                            </li>
                            <li>
                                <a href="https://www.linkedin.com/company/brew-your-brand">
                                    <svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M2.90719 4.1972C3.61209 4.1972 4.18353 3.62576 4.18353 2.92086C4.18353 2.21597 3.61209 1.64453 2.90719 1.64453C2.20229 1.64453 1.63086 2.21597 1.63086 2.92086C1.63086 3.62576 2.20229 4.1972 2.90719 4.1972Z">
                                        </path>
                                        <path
                                            d="M5.38752 5.16523V12.2463H7.5861V8.74457C7.5861 7.82057 7.75994 6.92573 8.9056 6.92573C10.0355 6.92573 10.0495 7.98215 10.0495 8.8029V12.2469H12.2493V8.36365C12.2493 6.45615 11.8386 4.99023 9.60911 4.99023C8.53869 4.99023 7.82119 5.57765 7.52777 6.13357H7.49802V5.16523H5.38752ZM1.80469 5.16523H4.00677V12.2463H1.80469V5.16523Z">
                                        </path>
                                    </svg>
                                </a>
                            </li>
                            <li>
                                <a href="https://www.instagram.com/brew_your_brand">
                                    <svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M12.2191 4.84492C12.2132 4.40312 12.1305 3.96571 11.9747 3.55226C11.8396 3.20351 11.6332 2.88679 11.3687 2.62233C11.1043 2.35786 10.7875 2.15147 10.4388 2.01634C10.0307 1.86313 9.59948 1.78029 9.16362 1.77134C8.60246 1.74626 8.42454 1.73926 7.00004 1.73926C5.57554 1.73926 5.39296 1.73926 4.83587 1.77134C4.40022 1.78036 3.96924 1.8632 3.56129 2.01634C3.21249 2.15138 2.89572 2.35773 2.63124 2.62221C2.36677 2.88669 2.16041 3.20346 2.02537 3.55226C1.87186 3.96008 1.7892 4.39116 1.78096 4.82684C1.75587 5.38859 1.74829 5.56651 1.74829 6.99101C1.74829 8.41551 1.74829 8.59751 1.78096 9.15517C1.78971 9.59151 1.87196 10.022 2.02537 10.4309C2.16064 10.7796 2.36715 11.0963 2.63171 11.3606C2.89628 11.625 3.21308 11.8313 3.56187 11.9663C3.96871 12.1256 4.39976 12.2144 4.83646 12.2288C5.39821 12.2538 5.57612 12.2614 7.00062 12.2614C8.42512 12.2614 8.60771 12.2614 9.16479 12.2288C9.60063 12.2202 10.0318 12.1375 10.44 11.9843C10.7886 11.8491 11.1053 11.6426 11.3697 11.3782C11.6341 11.1137 11.8406 10.7971 11.9759 10.4484C12.1293 10.0401 12.2115 9.60959 12.2203 9.17267C12.2454 8.61151 12.253 8.43359 12.253 7.00851C12.2518 5.58401 12.2518 5.40317 12.2191 4.84492ZM6.99654 9.68484C5.50671 9.68484 4.29979 8.47792 4.29979 6.98809C4.29979 5.49826 5.50671 4.29134 6.99654 4.29134C7.71176 4.29134 8.39769 4.57546 8.90343 5.0812C9.40917 5.58694 9.69329 6.27287 9.69329 6.98809C9.69329 7.70331 9.40917 8.38924 8.90343 8.89498C8.39769 9.40072 7.71176 9.68484 6.99654 9.68484ZM9.80062 4.82042C9.71802 4.8205 9.63622 4.80429 9.55989 4.77271C9.48356 4.74114 9.41421 4.69482 9.3558 4.63641C9.29739 4.57801 9.25108 4.50865 9.2195 4.43233C9.18793 4.356 9.17171 4.27419 9.17179 4.19159C9.17179 4.10905 9.18805 4.02732 9.21964 3.95106C9.25122 3.8748 9.29752 3.80551 9.35589 3.74714C9.41425 3.68878 9.48354 3.64248 9.5598 3.61089C9.63606 3.57931 9.71779 3.56305 9.80033 3.56305C9.88287 3.56305 9.96461 3.57931 10.0409 3.61089C10.1171 3.64248 10.1864 3.68878 10.2448 3.74714C10.3031 3.80551 10.3494 3.8748 10.381 3.95106C10.4126 4.02732 10.4289 4.10905 10.4289 4.19159C10.4289 4.53926 10.1477 4.82042 9.80062 4.82042Z">
                                        </path>
                                        <path
                                            d="M6.99589 8.73983C7.96336 8.73983 8.74764 7.95554 8.74764 6.98808C8.74764 6.02061 7.96336 5.23633 6.99589 5.23633C6.02843 5.23633 5.24414 6.02061 5.24414 6.98808C5.24414 7.95554 6.02843 8.73983 6.99589 8.73983Z">
                                        </path>
                                    </svg>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </header>





    <div className="blog-post-9 pt-20">
        <div className="container">
            <div className="inner-page-breadcrumb-wrapper mb-20">
                <ul>
                    <li><a href="/">Home</a></li>
                    {blogData?.category && (
                        <li><a href={`/${blogData.category.toLowerCase().replace(/ /g, "-")}`}>{blogData.category}</a></li>
                    )}
                    {blogData?.title && <li>{blogData.title}</li>}
                </ul>
            </div>
            <div className="row g-lg-4 gy-5">
                <div className="col-lg-8">
                <div className="post-thump">
                    <img
                        src={blogData?.banner
                            ? `https://api.skepper.in/uploads/${blogData.banner}`
                            : undefined}
                        alt={blogData?.title ? `${blogData.title} article banner` : "BYB eMagazine article banner"}
                    />
                </div>

                <ul className="post-meta">
                    <li>
                        {blogData?.created_by && <a href="#">{blogData.created_by}</a>}
                    </li>
                    <li>
                        {blogData?.created_at && (
                            <a className="publish-date" href="life-style.html">
                                {new Date(blogData.created_at).toLocaleDateString("en-US", {
                                    day: "2-digit", month: "short", year: "numeric"
                                })}
                            </a>
                        )}
                    </li>
                </ul>

                <h1>{blogData?.title || "Untitled Blog"}</h1>

                <div className="row justify-content-center">
                    <div className="col-lg-10 mb-60">
                        {blogData?.content && (
                            <div className="blog-content" dangerouslySetInnerHTML={{ __html: normalizedBlogContent }} />
                        )}
                    </div>
                </div>

                <div className="blog-tag">
                    <div className="author-name">
                        {blogData?.created_by && (
                            <h6>Posted by <a href="#"
                             style={{color:"#fff"}}>{blogData.created_by}</a></h6>
                        )}
                    </div>
                    <div className="tag-items">
                        <h6>Categorized:</h6>
                        {blogData?.tags}
                    </div>
                </div>

                <div className="post-btn">
        {isLoading ? (
            <p>Loading posts...</p>
        ) : error ? (
            <p style={{ color: "red" }}>{error}</p>
        ) : randomPosts.length >= 1 ? (
            <>
                <div className="privious-post-btn">
                    <a href={buildEmagazineArticlePath(randomPosts[0].category, randomPosts[0].slug)}>
                        <svg className="arrow" width="11" height="11" viewBox="0 0 11 11" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10 10L1 1M1 1C3 1.375 7.375 2.125 10 1M1 1C1.375 2.875 2.125 7 1 10" stroke="white" strokeWidth="1.5" strokeLinecap="round"></path>
                        </svg>
                        Previous Post
                    </a>
                </div>

                <div className="next-post-btn">
                    <a href={buildEmagazineArticlePath(randomPosts[1].category, randomPosts[1].slug)}>
                        <svg className="arrow" width="10" height="10" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 9L9 1M9 1C7.22222 1.33333 3.33333 2 1 1M9 1C8.66667 2.66667 8 6.33333 9 9" stroke="#191919" strokeWidth="1.5" strokeLinecap="round"></path>
                        </svg>
                        Next Post
                    </a>
                </div>
            </>
        ) : (
            <p>No posts available.</p>
        )}
    </div>


                    <div className="share-post-area">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="share-post-content">
                                    <h3>Share This Post</h3>
                                    <ul>
                                        <li>
                                            <a className="icon" href="https://www.facebook.com/BrewYourBrandOfficial/">
                                                <svg width="6" height="12" viewBox="0 0 6 12"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M3.81526 11.2483V6.46735H5.42818L5.66793 4.59543H3.81526V3.4031C3.81526 2.86293 3.96576 2.4931 4.74101 2.4931H5.72334V0.824182C5.24538 0.77296 4.76495 0.748228 4.28426 0.750099C2.85859 0.750099 1.87976 1.62043 1.87976 3.21818V4.59193H0.277344V6.46385H1.88326V11.2483H3.81526Z" />
                                                </svg>
                                            </a>
                                        </li>
                                        <li>
                                            <a className="icon" href="https://x.com/brew_your_brand">
                                                <svg width="14" height="14" viewBox="0 0 14 14"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <g>
                                                        <path
                                                            d="M11.025 0.65625H13.1722L8.48225 6.0305L14 13.3438H9.68012L6.2965 8.9075L2.42462 13.3438H0.2765L5.29287 7.595L0 0.65625H4.43013L7.48825 4.71012L11.025 0.65625ZM10.2725 12.0557H11.4625L3.78262 1.87687H2.50688L10.2725 12.0557Z" />
                                                    </g>
                                                </svg>
                                            </a>
                                        </li>
                                        <li>
                                            <a className="icon" href="https://www.linkedin.com/company/brew-your-brand">
                                                <svg width="14" height="14" viewBox="0 0 14 14"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M2.90719 4.1972C3.61209 4.1972 4.18353 3.62576 4.18353 2.92086C4.18353 2.21597 3.61209 1.64453 2.90719 1.64453C2.20229 1.64453 1.63086 2.21597 1.63086 2.92086C1.63086 3.62576 2.20229 4.1972 2.90719 4.1972Z">
                                                        </path>
                                                        <path
                                                            d="M5.38752 5.16523V12.2463H7.5861V8.74457C7.5861 7.82057 7.75994 6.92573 8.9056 6.92573C10.0355 6.92573 10.0495 7.98215 10.0495 8.8029V12.2469H12.2493V8.36365C12.2493 6.45615 11.8386 4.99023 9.60911 4.99023C8.53869 4.99023 7.82119 5.57765 7.52777 6.13357H7.49802V5.16523H5.38752ZM1.80469 5.16523H4.00677V12.2463H1.80469V5.16523Z">
                                                        </path>
                                                    </svg>
                                                </a>
                                            </li>
                                            <li>
                                                <a className="icon" href="https://www.instagram.com/brew_your_brand">
                                                    <svg width="14" height="14" viewBox="0 0 14 14"
                                                        xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M12.2191 4.84492C12.2132 4.40312 12.1305 3.96571 11.9747 3.55226C11.8396 3.20351 11.6332 2.88679 11.3687 2.62233C11.1043 2.35786 10.7875 2.15147 10.4388 2.01634C10.0307 1.86313 9.59948 1.78029 9.16362 1.77134C8.60246 1.74626 8.42454 1.73926 7.00004 1.73926C5.57554 1.73926 5.39296 1.73926 4.83587 1.77134C4.40022 1.78036 3.96924 1.8632 3.56129 2.01634C3.21249 2.15138 2.89572 2.35773 2.63124 2.62221C2.36677 2.88669 2.16041 3.20346 2.02537 3.55226C1.87186 3.96008 1.7892 4.39116 1.78096 4.82684C1.75587 5.38859 1.74829 5.56651 1.74829 6.99101C1.74829 8.41551 1.74829 8.59751 1.78096 9.15517C1.78971 9.59151 1.87196 10.022 2.02537 10.4309C2.16064 10.7796 2.36715 11.0963 2.63171 11.3606C2.89628 11.625 3.21308 11.8313 3.56187 11.9663C3.96871 12.1256 4.39976 12.2144 4.83646 12.2288C5.39821 12.2538 5.57612 12.2614 7.00062 12.2614C8.42512 12.2614 8.60771 12.2614 9.16479 12.2288C9.60063 12.2202 10.0318 12.1375 10.44 11.9843C10.7886 11.8491 11.1053 11.6426 11.3697 11.3782C11.6341 11.1137 11.8406 10.7971 11.9759 10.4484C12.1293 10.0401 12.2115 9.60959 12.2203 9.17267C12.2454 8.61151 12.253 8.43359 12.253 7.00851C12.2518 5.58401 12.2518 5.40317 12.2191 4.84492ZM6.99654 9.68484C5.50671 9.68484 4.29979 8.47792 4.29979 6.98809C4.29979 5.49826 5.50671 4.29134 6.99654 4.29134C7.71176 4.29134 8.39769 4.57546 8.90343 5.0812C9.40917 5.58694 9.69329 6.27287 9.69329 6.98809C9.69329 7.70331 9.40917 8.38924 8.90343 8.89498C8.39769 9.40072 7.71176 9.68484 6.99654 9.68484ZM9.80062 4.82042C9.71802 4.8205 9.63622 4.80429 9.55989 4.77271C9.48356 4.74114 9.41421 4.69482 9.3558 4.63641C9.29739 4.57801 9.25108 4.50865 9.2195 4.43233C9.18793 4.356 9.17171 4.27419 9.17179 4.19159C9.17179 4.10905 9.18805 4.02732 9.21964 3.95106C9.25122 3.8748 9.29752 3.80551 9.35589 3.74714C9.41425 3.68878 9.48354 3.64248 9.5598 3.61089C9.63606 3.57931 9.71779 3.56305 9.80033 3.56305C9.88287 3.56305 9.96461 3.57931 10.0409 3.61089C10.1171 3.64248 10.1864 3.68878 10.2448 3.74714C10.3031 3.80551 10.3494 3.8748 10.381 3.95106C10.4126 4.02732 10.4289 4.10905 10.4289 4.19159C10.4289 4.53926 10.1477 4.82042 9.80062 4.82042Z">
                                        </path>
                                        <path
                                            d="M6.99589 8.73983C7.96336 8.73983 8.74764 7.95554 8.74764 6.98808C8.74764 6.02061 7.96336 5.23633 6.99589 5.23633C6.02843 5.23633 5.24414 6.02061 5.24414 6.98808C5.24414 7.95554 6.02843 8.73983 6.99589 8.73983Z">
                                        </path>
                                    </svg>
                                </a>
                            </li>
                                    </ul>
                                    <div className="input-area" id="inviteCode">
                                        <input id="link-input" value={currentUrl} readOnly />
                                        <button type="button" id="copy-link-icon" onClick={handleCopyLink} aria-label="Copy article link" title={isLinkCopied ? "Copied" : "Copy link"}>
                                        <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.97324 10.9956C6.99524 11.0066 7.02724 11.0066 7.02724 11.0066V11.0286C7.06024 11.0286 7.12424 10.9846 7.12424 10.9846L8.29028 9.82042L8.32328 9.78845C8.35314 9.76404 8.37852 9.73462 8.39828 9.70151C8.42028 9.65854 8.43028 9.61457 8.40828 9.5716C8.38828 9.52863 8.35528 9.48566 8.31228 9.48566C7.87035 9.39014 7.46545 9.1691 7.14624 8.84912C6.76572 8.47567 6.53189 7.97821 6.48723 7.44712C6.45456 7.1118 6.49673 6.77341 6.61069 6.45634C6.72464 6.13926 6.90755 5.85138 7.14624 5.61343L10.2003 2.55962C11.0634 1.69624 12.5744 1.69624 13.4384 2.55962C13.8704 3.0023 14.1084 3.57389 14.1084 4.18845C14.1084 4.80301 13.8704 5.3856 13.4384 5.81729L12.0464 7.1983C12.0306 7.21556 12.0193 7.23645 12.0136 7.25912C12.0078 7.28178 12.0077 7.30551 12.0134 7.32821C12.1434 7.79088 12.2184 8.27653 12.2184 8.76218C12.2184 8.99901 12.2084 9.20387 12.1754 9.37674C12.1754 9.4307 12.1974 9.49566 12.2514 9.51664C12.2768 9.532 12.3066 9.53828 12.3361 9.53447C12.3655 9.53066 12.3928 9.51697 12.4134 9.49566L14.7775 7.14434C16.4075 5.50451 16.4075 2.85041 14.7775 1.22158C13.9921 0.43928 12.9283 0 11.8194 0C10.7104 0 9.6467 0.43928 8.86129 1.22158L5.80721 4.27539C5.5372 4.5452 5.32219 4.83699 5.16019 5.12778L5.14719 5.13778C5.13719 5.14577 5.12718 5.15276 5.12718 5.15976C4.79591 5.74751 4.61115 6.40632 4.58852 7.0805C4.56589 7.75467 4.70606 8.42438 4.99718 9.03299C5.20319 9.45269 5.46219 9.83042 5.80721 10.1762C6.14221 10.5209 6.54123 10.8017 6.97324 10.9956ZM1.23107 14.7709C2.0501 15.5803 3.12013 15.99 4.18816 15.99L4.15616 16C5.22419 16 6.30422 15.5903 7.11424 14.7819L10.1683 11.7291C10.727 11.1773 11.1165 10.4777 11.2914 9.7125L11.3564 9.23784C11.3774 9.12992 11.3774 9.02199 11.3774 8.91407V8.48338C11.3774 8.37446 11.3674 8.26654 11.3454 8.1806C11.3354 8.06168 11.3134 7.96475 11.2914 7.86782C11.2664 7.74735 11.234 7.62854 11.1944 7.51208C11.0008 6.87575 10.652 6.29748 10.1793 5.82928C9.84282 5.49624 9.45228 5.22256 9.0243 5.01986C8.9813 4.98788 8.87329 5.04184 8.87329 5.04184L7.70726 6.20601C7.67526 6.23899 7.63226 6.28196 7.59926 6.34591C7.57826 6.37889 7.57826 6.42186 7.59926 6.46582C7.62126 6.50879 7.65326 6.54077 7.69626 6.54077C8.13927 6.62671 8.53828 6.84256 8.86229 7.16632C9.29431 7.60901 9.53231 8.19159 9.52131 8.82713C9.51031 9.21685 9.41331 9.59359 9.2293 9.91635C9.17794 10.0094 9.11658 10.0965 9.0463 10.1762C9.0033 10.2411 8.9493 10.3161 8.86229 10.402L5.80721 13.4548C5.37361 13.8759 4.79279 14.1115 4.18816 14.1115C3.58352 14.1115 3.00271 13.8759 2.56911 13.4548C2.13942 13.0215 1.89858 12.436 1.89909 11.826C1.89909 11.2114 2.1371 10.6288 2.56911 10.1972L3.96215 8.80615C3.99415 8.76318 4.00515 8.70922 3.99415 8.66625C3.77779 8.01315 3.71483 7.31903 3.81015 6.6377C3.81488 6.60938 3.81008 6.58029 3.79651 6.55498C3.78294 6.52966 3.76136 6.50956 3.73515 6.4978C3.69214 6.46483 3.58414 6.51879 3.58414 6.51879L1.23007 8.85911C0.838368 9.24512 0.527785 9.70543 0.316558 10.213C0.105332 10.7206 -0.00228147 11.2653 3.66695e-05 11.815C3.66695e-05 12.9252 0.44305 13.9834 1.23007 14.7699L1.23107 14.7709Z"></path>
                                            </svg>
                                        </button>
                                        <span id="copy-text" className={`copy-text${isLinkCopied ? ' show' : ''}`}></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="subscribe-section">
                         <h3>Subscribe To Get Updates on Latest Blog Posts</h3>

                            <div className="input-area">
                                <input
                                    type="email"
                                    placeholder="Enter Email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    className=""
                                />
                                <button type="submit" className="subscriber-button" onClick={handleSubscribe}>
                                <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M15.9647 0.685806C16.0011 0.594942 16.01 0.495402 15.9904 0.399526C15.9707 0.303649 15.9233 0.215653 15.8541 0.146447C15.7849 0.0772403 15.6969 0.0298668 15.601 0.0101994C15.5052 -0.0094681 15.4056 -0.000564594 15.3147 0.0358061L0.76775 5.85481H0.76675L0.31475 6.03481C0.22914 6.06895 0.154635 6.1261 0.0994654 6.19994C0.0442956 6.27377 0.0106078 6.36142 0.00212322 6.4532C-0.00636132 6.54497 0.0106876 6.63731 0.0513867 6.72001C0.0920859 6.8027 0.154851 6.87254 0.23275 6.92181L0.64275 7.18181L0.64375 7.18381L5.63875 10.3618L8.81675 15.3568L8.81875 15.3588L9.07875 15.7688C9.12817 15.8464 9.19805 15.9089 9.28068 15.9493C9.36332 15.9897 9.45551 16.0066 9.54711 15.998C9.63871 15.9894 9.72617 15.9558 9.79985 15.9007C9.87354 15.8456 9.9306 15.7712 9.96475 15.6858L15.9647 0.685806ZM14.1317 2.57581L6.63775 10.0698L6.42275 9.73181C6.38336 9.66978 6.33078 9.6172 6.26875 9.57781L5.93075 9.36281L13.4247 1.86881L14.6027 1.39781L14.1327 2.57581H14.1317Z">
                                    </path>
                                </svg>
                                </button>
                            </div>

                                {message && <p className={`message ${messageType}`}>{message}</p>}

                                <p>
                                <svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_786_352)">
                                    <path d="M12 6C12 7.5913 11.3679 9.11742 10.2426 10.2426C9.11742 11.3679 7.5913 12 6 12C4.4087 12 2.88258 11.3679 1.75736 10.2426C0.632141 9.11742 0 7.5913 0 6C0 4.4087 0.632141 2.88258 1.75736 1.75736C2.88258 0.632141 4.4087 0 6 0C7.5913 0 9.11742 0.632141 10.2426 1.75736C11.3679 2.88258 12 4.4087 12 6ZM9.0225 3.7275C8.96893 3.67411 8.90514 3.63208 8.83495 3.60391C8.76476 3.57574 8.68961 3.56202 8.61399 3.56356C8.53838 3.5651 8.46385 3.58187 8.39486 3.61288C8.32588 3.64388 8.26385 3.68848 8.2125 3.744L5.60775 7.06275L4.038 5.49225C3.93137 5.39289 3.79033 5.3388 3.64461 5.34137C3.49888 5.34394 3.35984 5.40297 3.25678 5.50603C3.15372 5.60909 3.09469 5.74813 3.09212 5.89386C3.08955 6.03958 3.14364 6.18062 3.243 6.28725L5.2275 8.2725C5.28096 8.32586 5.34462 8.36791 5.41469 8.39614C5.48475 8.42437 5.55979 8.43819 5.63531 8.43679C5.71083 8.43539 5.7853 8.4188 5.85427 8.38799C5.92324 8.35719 5.9853 8.31281 6.03675 8.2575L9.03075 4.515C9.13282 4.40887 9.18921 4.26696 9.18781 4.11972C9.1864 3.97248 9.12732 3.83166 9.02325 3.7275H9.0225Z"></path>
                                </g>
                                <defs>
                                    <clipPath id="clip0_786_352">
                                        <rect width="12" height="12" fill="white"></rect>
                                    </clipPath>
                                </defs>
                            </svg>
                                    No Credit Card Required
                                </p>
                            </div>

                        <div className="blog-post-area pt-90 mb-5">
                            <h6>You May Also Like</h6>
                            <span className="line-break3"></span>
                            <span className="line-break"></span>
                            <div className="row gy-5">
                                {isLoading ? (
                                    <p>Loading posts...</p>
                                ) : error ? (
                                    <p style={{ color: "red" }}>{error}</p>
                                ) : randomPosts.length > 0 ? (
                                    randomPosts.map((post) => (
                                        <div className="col-md-6" key={post.id}>
                                            <div className="blog-card2 two">
                                                <div className="blog-card-img-wrap">
                                                    <a href={buildEmagazineArticlePath(post.category, post.slug)}>
                                                        <img src={`https://api.skepper.in/uploads/${post.image2}`} alt={post.title ? `${post.title} related article thumbnail` : "Related BYB eMagazine article thumbnail"} />
                                                    </a>
                                                    <ul className='px-0'>
                                                        <li>
                                                            <a className="category text-decoration-none" href={buildEmagazineCategoryPath(post.category)}>
                                                                {post.category}
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div className="blog-content">
                                                    <ul className="blog-meta">
                                                        <li><a href="#">{post.created_by}</a></li>
                                                        <li>
                                                            <a className="publish-date" href={buildEmagazineArticlePath(post.category, post.slug)}>
                                                                {new Date(post.created_at).toLocaleDateString("en-US", {
                                                                    day: "2-digit",
                                                                    month: "short",
                                                                    year: "numeric"
                                                                })}
                                                            </a>
                                                        </li>
                                                    </ul>
                                                    <h4>
                                                        <a href={buildEmagazineArticlePath(post.category, post.slug)}>
                                                            {post.title}
                                                        </a>
                                                    </h4>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <p>No posts available.</p>
                                )}
                            </div>
                        </div>

                </div>
                <div className="col-lg-4 ">
                    <div className="life-style-sidebar">

                        <div className="sidebar-widget featured-post">
                            <div className="d-flex mb-5">
                            {blogData && (
  <>
    <button
      onClick={() => handleToggle(blogData.id, 'approved', 1)}
      className="btn btn-success me-3"
    >
      Approve
    </button>
    <button
      onClick={() => handleToggle(blogData.id, 'approved', 0)}
      className="btn btn-danger"
    >
      Decline
    </button>
  </>
)}

                            </div>
                            <h6>Featured Post</h6>

                            {isLoading && <p>Loading posts...</p>}
                            {error && <p style={{ color: 'red' }}>{error}</p>}

                            {posts.length > 0 ? (
                                posts.map(post => (
                                    <div className="recent-post mb-20" key={post.id}>
                                        <div className="recent-post-img">
                                            <a href={`/blog/${post.slug}`}  className='text-decoration-none text-white'>
                                                <img src={`https://api.skepper.in/uploads/${post.image3}`} alt={post.title ? `${post.title} featured article thumbnail` : "Featured BYB eMagazine article thumbnail"} />
                                            </a>
                                        </div>
                                        <div className="recent-post-content">
                                            <a href={`/blog/${post.slug}`} className='text-decoration-none text-white'>
                                                {new Date(post.created_at).toLocaleDateString("en-US", {
                                                    day: "2-digit", month: "short", year: "numeric"
                                                })}
                                            </a>
                                            <h5>
                                                <a href={`/blog/${post.slug}`}  className='text-decoration-none text-white'>{post.title}</a>
                                            </h5>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                !isLoading && <p>No featured posts found.</p>
                            )}
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>


 <BybFooter/>

</div>
        </>
    );
};



export default BlogDetailPageDemo;
